import { render, staticRenderFns } from "./StepLocal.vue?vue&type=template&id=187e2638&scoped=true"
import script from "./StepLocal.vue?vue&type=script&lang=ts"
export * from "./StepLocal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187e2638",
  null
  
)

export default component.exports